<div [ngClass]="{ 'ellipse-hover-full-icons': (showRemoveBtn || showCreateSingleDimCardBtn), 'ellipse':true, 'border-gray':true }" [attr.content]="dimensionName.name" [style.--background-color]="dimensionName.bgColor" [style.--color]="dimensionName.fontColor">
    <b class="ellipse-text">{{ dimensionName.name }}</b>
    <div class="inline-icons icons icons-white">
        <a *ngIf="showRemoveBtn" (click)="onRemoveClicked()" class="icon">
            <img src="assets/images/icon-cross.svg" alt="x">
        </a>
        <a *ngIf="showCreateSingleDimCardBtn" (click)="onCreateSingleDimCardClicked()" class="icon">
            <img src="assets/images/icon-arrow-in.svg" alt=">">
        </a>
    </div>
</div>
